<template>
    <div class="userCenter_right" v-loading="loading">
        <div class="title_div">
            <span class="title_left" :style="dialogFormVisible?'color:#808080;':'color:#2d50a1'">应用列表</span>
            <i class="el-icon-arrow-right" v-show="dialogFormVisible"></i>
            <span class="title_left" v-show="dialogFormVisible">{{applicationTitle}}</span>
        </div>
        <div v-show="!dialogFormVisible">
            <div class="title_input">
                <div class="title_input_left">
                    <!--<el-input v-model="serachParm" placeholder="请输入内容"></el-input>-->
                    <el-input
                        placeholder="请输入应用名称"
                        size="medium"
                        v-model="serachParm">
                        <i slot="suffix" class="el-input__icon el-icon-search" @click="getApplication"></i>
                    </el-input>
                    <!--<el-button icon="el-icon-search" @click="getApplication" circle></el-button>-->
                </div>
                <div class="title_input_right">
                    <el-button type="success" style="padding: 5px;" @click="addApplication" icon="el-icon-circle-plus"
                               circle title="添加"></el-button>
                    <!--           <el-button type="warning" style="padding: 5px;"  icon="el-icon-edit" circle></el-button>-->
                    <el-button type="danger" style="padding: 5px;" @click="deleteApplication" icon="el-icon-delete"
                               circle title="删除"></el-button>
                </div>
            </div>
            <div class="tableContent" style="padding: 0 18px 20px;">
                <el-table
                    ref="singleTable"
                    :data="tableData"
                    border
                    el-table-column
                    @selection-change="handleSelectionChange"
                    style="width: 100%">
                    <el-table-column
                        type="selection"
                        header-align="center"
                        align="center"
                        width="55">
                    </el-table-column>
                    <el-table-column
                        label="序号"
                        type="index"
                        header-align="center"
                        align="center"
                        width="55">
                    </el-table-column>
                    <el-table-column
                        property="softwareTypeName"
                        sortable
                        label="类型名称"
                        show-overflow-tooltip
                        width="150">
                    </el-table-column>
                    <el-table-column
                        property="applicationName"
                        sortable
                        label="应用名称"
                        show-overflow-tooltip
                        width="230">
                    </el-table-column>
                    <el-table-column
                        property="deployUrl"
                        sortable
                        show-overflow-tooltip
                        label="应用地址">
                    </el-table-column>
                    <el-table-column
                        fixed="right"
                        label="操作"
                        header-align="center"
                        width="120">
                        <template slot-scope="scope">
                            <el-button type="text" @click="openUrl(scope.row)" size="small">进入应用</el-button>
                            <el-button type="text" @click="updateApplication(scope.row)" size="small">编辑</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="text-align: right;margin-top: 10px;">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage4"
                        :page-sizes="[5, 10, 20, 50]"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                    </el-pagination>
                </div>
            </div>
        </div>
        <div v-show="dialogFormVisible" class="addApplication">
            <el-form :model="form">
                <el-form-item label="应用类型" :label-width="formLabelWidth">
                    <el-select v-model="form.softwareType" placeholder="请选择分类" style="width: 300px;">
                        <el-option v-for="(item, index) in  softwareTypeList" :label="item.typeName" :key="index"
                                   :value="item.uuid"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="应用名称" :label-width="formLabelWidth">
                    <el-input v-model="form.applicationName" style="width: 300px;" autocomplete="off"></el-input>
                </el-form-item>

                <el-form-item label="应用地址" :label-width="formLabelWidth">
                    <el-input v-model="form.deployUrl" style="width: 300px;"></el-input>
                </el-form-item>
                <el-form-item label="上传logo" :label-width="formLabelWidth">
                    <el-upload
                        class="avatar-uploader"
                        action="/service-center/upload/file/single"
                        :show-file-list="false"
                        :headers="headers"
                        :on-success="handleAvatarSuccess"
                        :before-upload="beforeAvatarUpload">
                        <img v-if="imageUrl" :src="imageUrl" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"
                           style="border: 1px double  rgb(220 223 230);border-style: dashed;"></i>
                    </el-upload>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveApplication">确 定</el-button>
            </div>
        </div>
    </div>


</template>

<script>
    import {
        delSoftwareApplicationByUUIDList,
        getApplicationList,
        getNewcurrent,
        getSoftwareTypeList,
        saveApplication,

    } from "../../../utils/interface";
    export default {
        name: "index",
        data() {
            return {
                loading: false,
                imageUrl: '',
                serachParm: '',
                headers: {
                  'Authorization': 'Bearer ' + this.$cookies.get("api_access_token")	//	可以是授权凭证用的参数值
                },
                form: {
                    softwareType: '',
                    softwareName: '',
                    applicationName: '',
                    deployUrl: '',
                    logoUrl: '',
                    type: 1352,
                    createUser: '',
                    state: 1302,
                },
                softwareTypeList: [],
                currentPage4: 1,
                total: 0,
                pageSize: 10,
                formLabelWidth: '120px',
                dialogFormVisible: false,
                applicationTitle: '',
                tableData: [],
                userDetail: {},
                applicationList: [],
                changeRow: {},
                multipleSelection: [],
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            init(){
                this.serachParm = '';
                this.currentPage4 = 1;
                this.getSoftwareTypeList();
                this.getNewcurrent();
            },
            handleSelectionChange(val) {
                console.log(val)
                this.multipleSelection = val;
            },
            deleteApplication() {
                if (this.multipleSelection.length <= 0) {
                    this.$message('未选中应用!');
                } else {
                    this.$confirm('确定删除被选中的应用?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        let uuids = [];

                        for (let i = 0; i < this.multipleSelection.length; i++) {
                            uuids.push(this.multipleSelection[i].uuid);
                        }
                        console.log(uuids)
                        let param = {
                            uuidList: uuids,
                        }
                        delSoftwareApplicationByUUIDList(param).then((response) => {
                            this.getApplication();
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                        })

                    }).catch(() => {
                    });
                }
            },
            setCurrent(row) {
                this.$refs.singleTable.setCurrentRow(row);
            },
            updateApplication(row) {
                this.applicationTitle = '编辑应用'
                this.dialogFormVisible = true;
                this.imageUrl = row.logoUrl;
                this.form = row;
            },
            addApplication() {
                this.form = {};
                this.imageUrl = "";
                this.dialogFormVisible = true
                this.applicationTitle = '新增应用'
            },
            saveApplication() {
                this.form.logoUrl = this.imageUrl;
                if (!this.form.applicationName) {
                    this.$alert("应用名称不能为空!", "提示", {
                        confirmButtonText: "确定",
                    })
                    return false;
                }
                if (!this.form.deployUrl) {
                    this.$alert('应用地址不能为空', "提示", {
                        confirmButtonText: "确定",
                    })
                    return false;
                }
                let reg = /((ht|f)tps?:)\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/g;
//                    配出正确的url
                let hre = this.form.deployUrl.match(reg);
                if (hre == null) {
                    this.$alert('应用地址不正确!', "提示", {
                        confirmButtonText: "确定",
                    })
                    return false;
                }
                if( this.imageUrl == undefined ||  this.imageUrl == ""){
                    this.$alert('logo不能为空!', "提示", {
                        confirmButtonText: "确定",
                    })
                    return false;
                }

                this.form.type = 1352;
                this.form.state = 1302;
                saveApplication(this.form).then((response) => {
                    this.form = {};
                    this.imageUrl = "";
                    this.dialogFormVisible = false;
                    this.getApplication();
                    this.$alert('保存成功!', "提示", {
                        confirmButtonText: "确定",
                    })
                })
            },
            openUrl(row) {
                window.open(row.deployUrl);
            },
            getApplication() {
                let param = {
                    applicationName: this.serachParm,
                    current: this.currentPage4,
                    pageSize: this.pageSize,
                    userId: this.userDetail.uuid,
                    type: 1352
                }
                this.loading = true
                getApplicationList(param).then((res) => {
                    this.tableData = res.list;
                    this.total = res.total;
                    this.loading = false
                })
            },
            getNewcurrent() {
                if (!this.$store.state.isLogin) {
                    this.$router.push({name: "login", params: {uuid: uuid}});
                    return;
                }
                getNewcurrent().then((res) => {
                    console.log(res)
                    this.userDetail = res;
                    this.getApplication();
                })
            },

            getSoftwareTypeList() {
                let params = {
                    current: 1,
                    pageSize: 100,
                };
                getSoftwareTypeList(params).then((res) => {
                    if (res.list.length > 0) {
                        this.softwareTypeList = res.list;
                    }
                });
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.getApplication();
            },
            handleCurrentChange(val) {
                console.log(val)
                this.currentPage4 = val;
				window.scrollTo(0,0);
                this.getApplication();
            },
            handleAvatarSuccess(res, file) {
                console.log(res, file)
                this.loading = false
                this.imageUrl = res.url;
            },
            beforeAvatarUpload(file) {
                const isJPG = file.type === 'image/jpeg';
                let fileTypes = ['.jpg', '.png', '.jpeg', '.bmp', '.JPG', '.PNG', '.JPEG', '.BMP']
                let fileName = file.name.lastIndexOf('.')
                const fileNameLen = file.name.length
                const fileTypeName = file.name.substring(fileName, fileNameLen)
                let fileIndex = fileTypes.indexOf(fileTypeName)
                if (fileIndex === -1) {
                    this.$alert("只能上传图片格式", "提示", {
                        confirmButtonText: "确定",
                    })
                }
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (fileIndex === -1) {
                    this.$alert("只能上传图片格式", "提示", {
                        confirmButtonText: "确定",
                    })
                }
                if (!isLt2M) {
                    this.$alert("上传头像图片大小不能超过 2MB!", "提示", {
                        confirmButtonText: "确定",
                    })
                }
                if (fileIndex !== -1 && isLt2M) {
                    this.loading = true
                } else {
                    this.loading = false
                }
                return fileIndex !== -1 && isLt2M;
            },
        }
    }
</script>

<style scoped lang="less">
    .addApplication {
        padding: 20px 18px;

        .dialog-footer {
            text-align: center;

            /deep/ .el-button--primary {
                background-color: #2d50a1;
                border-color: #2d50a1;

                &:hover {
                    background: #66b1ff;
                    border-color: #66b1ff;
                }
            }
        }
    }

    .tableContent {
        /deep/ .el-table .el-table__cell {
            padding: 5px 0;
        }
    }

    .zZindex {
        position: relative;
        z-index: 999;
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    .userCenter_right {
        width: 966px;
        background: #fff;

        h4 {
            color: #2d50a1;
            padding: 20px 18px;
            border-bottom: 2px solid #f9f9f9;
        }

        .title_div {
            padding: 20px 18px;
            border-bottom: 2px solid #f9f9f9;
        }

        .title_input {
            padding: 20px 18px;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .title_input_left {
            width: 300px;

            .el-input__icon {
                cursor: pointer;

                &:hover {
                    color: #2d50a1;
                }
            }
        }

        .title_input_right {
        }

        .title_left {
            font-weight: bold;
            color: #2d50a1;
        }

        .title_right {
            float: right;
            margin-right: 30px;
        }

        .userCenter_right_box {
            padding: 30px 18px;

            .formItem {
                display: flex;
                margin-bottom: 30px;
                position: relative;

                .title {
                    width: 150px;
                    line-height: 40px;
                    letter-spacing: 1px;
                    color: #494a4c;
                }

                .inputClass {
                    width: 70%;
                }
            }

            .buttonGroupClass {
                text-align: right;

                button {
                    padding: 8px 12px;
                    background-color: #2d50a1;
                    border-color: #2d50a1;

                    &:hover {
                        background-color: #4a96f1;
                        border-color: #4a96f1;
                    }

                    i {
                        padding-right: 5px;
                        font-size: 14px;
                    }
                }
            }
        }
    }
    /deep/.el-pager li.active {
        // color: #2d50a1;
    }
</style>



// WEBPACK FOOTER //
// src/components/registeredLogin/applicationManage/index.vue